import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

export const IntroductionSession = () => {
  usePageView();
  const { t } = useTranslation();
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  const subscibre = useRef<HTMLDivElement>(null);

  return (
    <>
      <Seo title={t("introduction_sessions_title", "Introduction sessions")} />
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "neutral.900" : "neutral.100",
        }}
      >
        {/* Header Section with Background Image */}
        <Box
          sx={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundImage: "url(assets/gallery/workshopclass.jpg)",
            color: "common.black",
            textAlign: "center",
            position: "relative",
            py: mdUp ? 20 : 10, // Adjust padding to better fit the image
          }}
        >
          {/* Overlay for Darkening Effect */}
          <Box
            sx={{
              background:
                "linear-gradient(to bottom, white, rgba(0, 0, 0, 0.1))",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
            }}
          />
          <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
            <Box
              sx={{
                backgroundColor: "common.white",
                borderRadius: 4,
                height: mdUp ? "500px" : "",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0.8,
                border: 3,
                m: 3,
                p: 3,
                borderColor: "primary.main",
              }}
            >
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", mb: 2, color: "primary.main" }}
              >
                {t("introduction_sessions_heading", "Informatie sessie")}
              </Typography>
              <Typography variant="subtitle1" sx={{ mb: 4 }}>
                {t(
                  "introduction_sessions_paragraph_1",
                  "Heb je weleens het gevoel dat je jouw opensource loopers beter zou willen ondersteunen, maar weet je niet precies waar je moet beginnen? Maak je geen zorgen, want wij staan klaar om je te helpen!"
                )}
              </Typography>
              <Typography variant="subtitle1" sx={{ mb: 4 }}>
                {t(
                  "introduction_sessions_paragraph_2",
                  "Nodig ons uit voor een inspirerende introductiesessie, op locatie of online, waarin we samen ontdekken hoe wij jouw opensource loopers kunnen begeleiden en ondersteunen. Tijdens deze sessie laten we je zien hoe onze aanpak jouw team kan helpen om nog beter en efficiënter aan de slag te gaan. Samen zorgen we ervoor dat jouw opensource loopers alle tools en inzichten krijgen die ze nodig hebben om succesvol te zijn."
                )}
              </Typography>
              {/* <Typography variant="subtitle1" sx={{ mb: 4 }}>
                {t(
                  "introduction_sessions_paragraph_3",
                  "Neem contact met ons op voor meer informatie of om een introductiesessie in te plannen."
                )}
              </Typography> */}
              <Box>
                <Button
                  variant="contained"
                  href="mailto:info@opensource.clinic?subject=aanvraag%20informatie%20sessie"
                  size={!mdUp ? "medium" : "large"}
                  target="_blank"
                  sx={{
                    width: !mdUp ? "100%" : "auto",
                    textTransform: "none",
                  }}
                >
                  {t("contact_us_button", "Neem contact op")}
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
};
